import {
  ApolloClient,
  ApolloLink,
  InMemoryCache,
  Observable
} from '@apollo/client';
import { BACKEND_URL } from './constants';
import { createUploadLink } from 'apollo-upload-client';
import { onError, ErrorHandler } from '@apollo/client/link/error';

type graphQlError = {
  message: string;
};
const onApolloClientError = (
  error: ErrorHandler & { graphQLErrors: [graphQlError] }
) => {
  if (error && error.graphQLErrors) {
    console.error(error.graphQLErrors[0]?.message || 'error Apollo Client');
  }
};

const getApolloClient = async (): Promise<ApolloClient<any>> => {
  const cache = new InMemoryCache({});
  const requestLink = new ApolloLink(
    (operation, forward) =>
      new Observable((observer) => {
        let handle: any;
        Promise.resolve(operation)
          .then(async () => {
            const params = new URLSearchParams(window.location.search);
            const accessToken = params.get('accessToken');
            if (accessToken) {
              operation.setContext({
                headers: {
                  authorization: `bearer ${accessToken}`
                }
              });
            }
          })
          .then(() => {
            handle = forward(operation).subscribe({
              next: observer.next.bind(observer),
              error: observer.error.bind(observer),
              complete: observer.complete.bind(observer)
            });
          })
          .catch(observer.error.bind(observer));

        return () => {
          if (handle) handle.unsubscribe();
        };
      })
  );

  return new ApolloClient<any>({
    link: ApolloLink.from([
      // @ts-ignore
      onError(onApolloClientError),
      requestLink,
      // @ts-ignore
      createUploadLink({
        uri: BACKEND_URL
      })
    ]),
    cache
  });
};

export default getApolloClient;
